import { InstitutionAddEditFormFields, NurseryInformationDto } from 'types';

export const parseNurseryInformationDtoIntoInstitutionAddEditFormFields: (
    nurseryInformation: NurseryInformationDto,
) => Partial<InstitutionAddEditFormFields> = (nurseryInformation) => {
    const { city, premisesNumber, buildingNumber, registryNumber, zipCode, street, name } =
        nurseryInformation;
    return {
        institutionName: name,
        city,
        zipCode,
        nurseryRegistryNumber: registryNumber,
        street: `${street} ${buildingNumber}${premisesNumber ? `/${premisesNumber}` : ''}`,
    };
};
